import { twMerge } from "tailwind-merge";

import Flex from "../flex/Flex";

type BadgeProps = {
  children: string | number | React.ReactNode;
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>;

/**
 *  Badge component to display a badge with a value
 * - The badge is displayed as a rounded rectangle with a gray background and a primary text color.
 * - rounded-full py-1 px-2
 * - bg-gray-100 (backgroundColor: #ebedef)
 * - text-primary (color: #3b3f44)
 * - font-semibold (font-weight: 600)
 * - text-xs (font-size: 12px, line-height: 16px)
 * - The badge can have a value of type string, number or ReactNode.
 * @param children - The value to display in the badge
 * @param className - Additional classes to apply to the badge
 */
const Badge = ({ children, className, ...props }: BadgeProps) => {
  return (
    <Flex
      className={twMerge(
        "justify-center items-center rounded-3xl bg-gray-100 py-1 px-2 min-w-6 text-primary font-semibold text-xs",
        className
      )}
      data-testid="badge"
      {...props}
    >
      {children}
    </Flex>
  );
};

export default Badge;
